import { useState } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { useAuth } from '@/hooks/useAuth';
import { X, Lock } from '@phosphor-icons/react';

const M = "'IBM Plex Mono', monospace";

interface UpgradeModalProps {
  open: boolean;
  onClose: () => void;
  title?: string;
  description?: string;
}

export function UpgradeModal({ open, onClose, title, description }: UpgradeModalProps) {
  const { session } = useAuth();
  const [loading, setLoading] = useState<'month' | 'year' | null>(null);

  if (!open) return null;

  const handleCheckout = async (interval: 'month' | 'year') => {
    if (!session) return;
    setLoading(interval);
    try {
      const { data, error } = await supabase.functions.invoke('create-checkout-session', {
        body: { plan: 'pro', interval },
        headers: { Authorization: `Bearer ${session.access_token}` },
      });
      if (error) throw error;
      if (data?.url) {
        window.open(data.url, '_blank');
      }
    } catch (e) {
      console.error('Checkout error:', e);
    } finally {
      setLoading(null);
    }
  };

  return (
    <div
      style={{
        position: 'fixed', inset: 0, zIndex: 9999,
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        backgroundColor: 'rgba(0,0,0,0.7)',
      }}
      onClick={onClose}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          backgroundColor: 'rgba(247,246,242,0.06)',
          border: '0.5px solid rgba(247,246,242,0.1)',
          padding: 32,
          maxWidth: 420,
          width: '90%',
          position: 'relative',
        }}
      >
        <button
          onClick={onClose}
          style={{
            position: 'absolute', top: 12, right: 12,
            background: 'none', border: 'none', color: 'rgba(247,246,242,0.5)',
            cursor: 'pointer',
          }}
        >
          <X size={16} />
        </button>

        <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 16 }}>
          <Lock size={18} weight="thin" style={{ color: 'rgba(247,246,242,0.4)' }} />
          <h3 style={{ fontFamily: M, fontSize: 14, fontWeight: 400, color: '#F7F6F2', margin: 0 }}>
            {title || 'Recurso exclusivo do plano Pro'}
          </h3>
        </div>

        <p style={{ fontFamily: M, fontSize: 12, fontWeight: 300, color: 'rgba(247,246,242,0.6)', marginBottom: 24, lineHeight: 1.6 }}>
          {description || 'Faça upgrade para o plano Pro e desbloqueie todos os recursos avançados.'}
        </p>

        <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
          <button
            onClick={() => handleCheckout('month')}
            disabled={loading !== null}
            style={{
              fontFamily: M, fontSize: 12, fontWeight: 400,
              padding: '12px 16px',
              backgroundColor: '#F7F6F2',
              color: '#000000',
              border: 'none',
              cursor: loading ? 'wait' : 'pointer',
              textTransform: 'uppercase',
              letterSpacing: '0.05em',
              opacity: loading === 'year' ? 0.5 : 1,
            }}
          >
            {loading === 'month' ? 'Redirecionando...' : 'ASSINAR PRO — R$59,90/mês'}
          </button>

          <button
            onClick={() => handleCheckout('year')}
            disabled={loading !== null}
            style={{
              fontFamily: M, fontSize: 12, fontWeight: 400,
              padding: '12px 16px',
              backgroundColor: 'transparent',
              color: 'rgba(247,246,242,0.8)',
              border: '0.5px solid rgba(247,246,242,0.2)',
              cursor: loading ? 'wait' : 'pointer',
              textTransform: 'uppercase',
              letterSpacing: '0.05em',
              opacity: loading === 'month' ? 0.5 : 1,
            }}
          >
            {loading === 'year' ? 'Redirecionando...' : 'PLANO ANUAL — R$599,00/ano (economize 17%)'}
          </button>

          <button
            onClick={onClose}
            style={{
              fontFamily: M, fontSize: 12, fontWeight: 300,
              color: 'rgba(247,246,242,0.4)',
              background: 'none', border: 'none',
              cursor: 'pointer',
              marginTop: 8,
            }}
          >
            Fechar
          </button>
        </div>
      </div>
    </div>
  );
}
